import { LocationEvent } from '../models/locations/LocationEvent';
import { ILocationEventDetailRepository } from '../repositories/ILocationEventDetailRepository';

export class GetLocationEventDetailUseCase {
  constructor(private readonly repository: ILocationEventDetailRepository) {}

  async execute(locationId: string, eventId: string): Promise<LocationEvent> {
    return this.repository.getLocationEventDetail(locationId, eventId);
  }
}
